import React, { Component } from 'react';
import Alert from "@amzn/meridian/alert";
import {FormattedMessage} from "react-intl";

class ErrorPage extends Component {
    render() {
        return (
            <Alert
                type="error"
                size="takeover"
            >
                <FormattedMessage id={this.props.errorId} defaultMessage={this.props.errorMessage}>
                </FormattedMessage>
            </Alert>
        )
    };
};

export default ErrorPage;



// WEBPACK FOOTER //
// ./src/components/utils/ErrorPage.js